import { defineStore } from 'pinia'
import type PaymentStoreI from '@/typescript/types/stores/PaymentStoreI'
import type { PaymentState } from '@/typescript/types/stores/PaymentStoreI'
import ApiExceptionError from '@/entities/errors/api_errors/ApiExceptionError'
import PaymentMethodTransformHelper from '@/utils/paymentMethodsTransformHelpers'
import { Gateway } from '@/typescript/types/global/Gateways'

export const usePaymentStore: () => PaymentStoreI = defineStore('payment', {
  state: () =>
    ({
      stripePublishableKey: '',
      stripeIntentToken: '',
      globalPaymentMethods: [],
    }) as PaymentState,
  getters: {},
  actions: {
    async loadStripeIntentToken() {
      const response = await this.$services.global.getStripeIntentToken()
      if (!response?.data?.setup_intent) {
        console.error('No Stripe intent token recieved!')
        throw new ApiExceptionError()
      }
      this.stripeIntentToken = response.data.setup_intent
      return response
    },
    async loadStripeApiKey() {
      const response = await this.$services.global.getGlobalPaymentMethods()
      if (!response.data?.gateways?.stripe?.publishableKey) {
        console.error('No Stripe API key recieved!')
        throw new ApiExceptionError()
      }
      this.stripePublishableKey = response.data?.gateways?.stripe?.publishableKey
      const visibleMethods = this.getVisibleGlobalMethods(response.data.gateways)
      this.globalPaymentMethods = PaymentMethodTransformHelper.transformToPaymentMethod(visibleMethods)
      return response
    },
    async getGlobalPaymentMethods() {
      const response = await this.$services.global.getGlobalPaymentMethods()
      const visibleMethods = this.getVisibleGlobalMethods(response.data.gateways)
      this.globalPaymentMethods = PaymentMethodTransformHelper.transformToTitleValue(visibleMethods)
    },
    getVisibleGlobalMethods(globalMethods: Gateway[]) {
      return Object.fromEntries(Object.entries(globalMethods).filter(([, gateway]) => (gateway as Gateway).visible))
    },
    resetStripeIntentToken() {
      this.stripeIntentToken = ''
    },
  },
})
